// ============================================================
// HostexMappingCard.jsx - set + test the Hostex property_id mapping.
// Lives inside the property page's Content tab.
// ============================================================

import { useState } from 'react';

const IconCheck = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5"/></svg>;
const IconLink = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M10 13a5 5 0 007.07 0l2.83-2.83a5 5 0 00-7.07-7.07l-1.5 1.5"/><path d="M14 11a5 5 0 00-7.07 0L4.1 13.83a5 5 0 007.07 7.07l1.5-1.5"/></svg>;

export default function HostexMappingCard({ propertyId, currentValue, m, toast, onSaved }) {
  const [value, setValue] = useState(currentValue || '');
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const save = async () => {
    const res = await m(`/admin/properties/${propertyId}/content`, {
      method: 'PATCH',
      body: JSON.stringify({ hostex_property_id: value.trim() || null }),
    });
    const data = await res.json();
    if (data.success) { toast('Mapping Hostex enregistre', 'ok'); onSaved?.(); }
    else toast(data.error || 'Erreur', 'err');
  };

  const test = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const res = await m(`/admin/properties/${propertyId}/test-hostex`, { method: 'POST' });
      const data = await res.json();
      setTestResult(data);
      toast(data.success ? 'Connexion Hostex reussie' : (data.error || 'Echec'), data.success ? 'ok' : 'err');
    } catch (e) {
      toast('Erreur reseau', 'err');
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="ff">
      <label className="fl">ID de propriete Hostex</label>
      <div style={{ display: 'flex', gap: 8 }}>
        <input className="fi" value={value} onChange={(e) => setValue(e.target.value)} placeholder="hx_9001" style={{ fontFamily: 'var(--font-mono)' }} />
        <button className="btn btn-s" onClick={save} type="button">Enregistrer</button>
        <button className="btn btn-s" onClick={test} disabled={testing || !currentValue} type="button">
          {testing ? <span className="spin" /> : <>{IconLink} Tester</>}
        </button>
      </div>
      {testResult && (
        <div style={{ marginTop: 8, fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, color: testResult.success ? 'var(--green)' : 'var(--red)' }}>
          {testResult.success ? IconCheck : null}
          {testResult.success
            ? `Connecte — "${testResult.data.hostex_name || 'propriete'}" trouvee sur Hostex`
            : testResult.error}
        </div>
      )}
      <div style={{ fontSize: 11, color: 'var(--g2)', marginTop: 4 }}>
        Utilise pour lier les reservations Hostex a cette propriete via webhook (mapping 1:1).
      </div>
    </div>
  );
}
